import TasksContainer from '../../components/TasksContainer';
import React from 'react';

const TasksPage = () => <TasksContainer />;

export default TasksPage;
